!function(){"use strict";customElements.get("contact-form-message")||customElements.define("contact-form-message",class extends HTMLElement{constructor(){super()}connectedCallback(){this.hidePopups(),this.closeFormMessage(),this.autoHideMessage()}hidePopups(){document.body.classList.add("notification-visible")}showPopups(){document.body.classList.remove("notification-visible")}closeFormMessage(){this.querySelector("[data-form-message-close]").addEventListener("click",this.closeMessage.bind(this))}closeMessage(s){s.preventDefault(),this.classList.add("hide-down"),this.showPopups()}autoHideMessage(){setTimeout((()=>{this.classList.add("hide-down"),this.showPopups()}),1e4)}})}();

document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);

  if (params.get('contact_posted') === 'true') {
    const contactSection = document.querySelector('.section-contact-form');

    if (contactSection) {
      setTimeout(function () {
        const y =
          contactSection.getBoundingClientRect().top +
          window.pageYOffset -
          280;

        window.scrollTo({
          top: Math.max(y, 0),
          behavior: 'smooth'
        });
      }, 100);
    }
  }
});